Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMService = void 0;
var DOMService = (function () {
    function DOMService() {
    }
    DOMService.prototype.loadScript = function (microviewName, url) {
        return new Promise(function (resolve, reject) {
            var scriptTag = document.createElement('SCRIPT');
            scriptTag.setAttribute('src', url);
            scriptTag.className = microviewName + 'MicroViewScript';
            document.body.appendChild(scriptTag);
            scriptTag.onload = function () {
                resolve();
            };
            scriptTag.onerror = function () {
                reject();
            };
        });
    };
    DOMService.instance = new DOMService();
    return DOMService;
}());
exports.DOMService = DOMService;
//# sourceMappingURL=DOMService.js.map